import React, { useEffect } from "react";

const NotixTag = ({ isAuthenticated, user }) => {
  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    window.NotixSDK?.startInstall({
      appId: "1004167fd60ba0cd4ef8df922419b72",
      loadSettings: true,
      user: String(user.id),
    });
  }, [isAuthenticated, user?.id]);

  return <div className="Notix_Tag_Stub" />;
};

export default NotixTag;
